module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai186-c60e0245a3c079349b4d29f542952807.jpg";